var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1067 11.0401L45.92 21.1468C45.8933 22.5334 46.7734 24.3735 47.8934 25.2001L54.5067 30.2134C58.7467 33.4134 58.0534 37.3335 52.9867 38.9335L44.3734 41.6267C42.9334 42.0801 41.4134 43.6535 41.0401 45.1201L38.9867 52.9601C37.36 59.1467 33.3067 59.7601 29.9467 54.3201L25.2533 46.7201C24.4 45.3334 22.3733 44.2935 20.7733 44.3735L11.8668 44.8268C5.49342 45.1468 3.68006 41.4668 7.84006 36.6135L13.12 30.4801C14.1067 29.3334 14.56 27.2001 14.1067 25.7601L11.4135 17.1468C9.84013 12.0801 12.6668 9.28012 17.7068 10.9335L25.5735 13.5201C26.9068 13.9468 28.9067 13.6534 30.0267 12.8268L38.2401 6.90676C42.6668 3.70676 46.2133 5.57348 46.1067 11.0401Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4266 58.6667L50.3467 50.5867",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicStar);
export default __webpack_public_path__ + "static/media/magic-star.43ee6aa0bb96cadfbb4a06abdf60689a.svg";
export { ForwardRef as ReactComponent };